export default "__VITE_ASSET__CwljCXxl__"